import React,{useState} from "react";
import {signInWithEmailAndPassword} from "firebase/auth";
import {auth} from "../../firebase/firebase.js";
import {useNavigate} from "react-router-dom";

export default function BusinessLogin(){

  const[email,setEmail]=useState("");
  const[password,setPassword]=useState("");
  const[error,setError]=useState("");
  const[loading,setLoading]=useState(false);

  const nav=useNavigate();

  const submit=async(e)=>{
    e.preventDefault();

    if(!email || !password){
      setError("Email and password required.");
      return;
    }

    setError("");
    setLoading(true);

    try{
      await signInWithEmailAndPassword(auth,email,password);

      // ✅ wait one tick so AuthContext updates before RequireAuth runs
      setTimeout(()=>{
        nav("/business/dashboard",{replace:true});
      },0);

    }catch(err){
      setError("Incorrect business login.");
    }

    setLoading(false);
  };

  return(
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <form onSubmit={submit} className="bg-neutral-900 p-8 rounded-xl w-[360px]">

        <h2 className="text-2xl font-bold mb-6 text-center">
          Business Login
        </h2>

        <input
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          placeholder="Email"
          className="w-full mb-4 p-3 rounded bg-neutral-800"
        />

        <input
          type="password"
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
          placeholder="Password"
          className="w-full mb-4 p-3 rounded bg-neutral-800"
        />

        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-yellow-500 text-black py-3 rounded font-semibold"
        >
          {loading ? "Signing in…" : "Business Login"}
        </button>

      </form>
    </div>
  );
}
